import { ACTIVE_TAB_EXPIRATION, DEFAULT_CHAT_HEIGHT } from '../constants';
import { LocalStorageKey } from '../model/enumeration/LocalStorageKey';

class LocalStorageStore {
  public getTokenWithoutPrefix = (): string =>
    this.getToken().replace('Basic ', '');

  public getLoggedUsername = (): string => {
    const token = window.atob(this.getTokenWithoutPrefix());
    return token.substring(0, token.indexOf(':'));
  };

  public getLoggedPassword = (): string => {
    const token = window.atob(this.getTokenWithoutPrefix());
    return token.substring(token.indexOf(':') + 1);
  };

  public addToken = (token: string): void => {
    localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, token);
  };

  public removeToken = (): void => {
    localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
  };

  public getToken = (): string =>
    localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);

  public isDebug = (): boolean =>
    Boolean(localStorage.getItem(LocalStorageKey.DEBUG));

  public setChipsConvertedToBlinds = (
    isChipsConvertedToBlinds: boolean,
  ): void =>
    localStorage.setItem(
      LocalStorageKey.IS_CHIPS_CONVERTED_TO_BLINDS,
      String(isChipsConvertedToBlinds),
    );

  public isChipsConvertedToBlinds = (): boolean => {
    const isChipsConvertedToBlinds = localStorage.getItem(
      LocalStorageKey.IS_CHIPS_CONVERTED_TO_BLINDS,
    );
    return isChipsConvertedToBlinds === 'true';
  };

  public setChatHeight = (chatHeight: number): void => {
    localStorage.setItem(LocalStorageKey.CHAT_HEIGHT, chatHeight.toString());
  };

  public getChatHeight = (): number =>
    Number(localStorage.getItem(LocalStorageKey.CHAT_HEIGHT)) ||
    DEFAULT_CHAT_HEIGHT;

  public setPinnedSidebar = (isPinnedSidebar: boolean): void => {
    localStorage.setItem(
      LocalStorageKey.IS_PINNED_SIDEBAR,
      String(isPinnedSidebar),
    );
  };

  public isPinnedSidebar = (): boolean => {
    const isPinnedSidebar = localStorage.getItem(
      LocalStorageKey.IS_PINNED_SIDEBAR,
    );
    return isPinnedSidebar === 'true';
  };

  public initActiveTab = (): string => {
    const activeTabId = `${LocalStorageKey.ACTIVE_TAB}_${crypto.randomUUID()}`;
    localStorage.setItem(activeTabId, Date.now().toString());
    return activeTabId;
  };

  public setActiveTab = (key: string): void => {
    localStorage.setItem(key, Date.now().toString());
  };

  public removeActiveTab = (key: string): void => {
    localStorage.removeItem(key);
  };

  public checkActiveTabs = (): number => {
    let activeTabLength = 0;

    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(LocalStorageKey.ACTIVE_TAB)) {
        if (
          Date.now() - Number(localStorage.getItem(key)) >
          ACTIVE_TAB_EXPIRATION
        ) {
          localStorage.removeItem(key);
        } else {
          activeTabLength += 1;
        }
      }
    });
    return activeTabLength;
  };

  public setAutoFilterOptions = (autoFilterOptions: boolean): void => {
    localStorage.setItem(
      LocalStorageKey.AUTO_FILTER_OPTIONS,
      String(autoFilterOptions),
    );
  };

  public getAutoFilterOptionsOrDefault = (
    defaultFilterOptions: boolean,
  ): boolean => {
    if (localStorage.getItem(LocalStorageKey.AUTO_FILTER_OPTIONS) === null) {
      this.setAutoFilterOptions(defaultFilterOptions);
      return defaultFilterOptions;
    }
    return localStorage.getItem(LocalStorageKey.AUTO_FILTER_OPTIONS) === 'true';
  };
}

const localStorageStore = new LocalStorageStore();
export default localStorageStore;
